import { BsFillPlayCircleFill } from 'react-icons/bs';
import { getTimeFromSecs } from '@wajeez-web/core/utils';
export interface EpisodeCardProps {
  img?: string;
  title?: string;
  description?: string;
  time?: number;
  onClick: () => void;
}

export const EpisodeCard = ({
  img = '',
  title = '',
  description = '',
  time = 0,
  onClick,
}: EpisodeCardProps) => {
  return (
    <div
      onClick={onClick}
      className="bg-[#F2F3F5] items-center flex justify-between my-2 space-y-[8px] px-5 py-4 rounded-[10px] cursor-POINTER shadow-md "
    >
      <div className=" flex items-center space-s-6">
        <img src={img} className="w-[93.1px] h-[97px]  rounded-[10px]" alt="" />
        <div className="pl-[80px]">
          <div className="text-[#27160E] text-xl font-bold">{title}</div>
          <div className="mt-1 text-[#545454] text-[20px] font-medium">
            {description}
          </div>
        </div>
      </div>
      <div className="flex space-s-2">
        <div className="text-[#666666] text-[17px] font-medium">
          {getTimeFromSecs(time / 1000)}
        </div>
        <BsFillPlayCircleFill className="text-primary h-[25px] w-[24px]" />
      </div>
    </div>
  );
};
